<template>
  <div class="mycourse">
    <van-tabs @click="tabClick">
      <van-tab
        v-for="(item, index) in categoryList"
        :title="item.name"
        :key="index"
      >
      </van-tab>
    </van-tabs>
    <courseCell
      :coursedata="courseList"
      :loading="listLoading"
      :finished="listFinished"
      @footerRefresh="getcourse"
      @watchCourse="watchCourse"
    ></courseCell>
  </div>
</template>
<script>
import courseCell from "../viewcomponents/courseCell";
import { getMyCourse } from "@/api/apis";
export default {
  data() {
    return {
      categoryList: [{ name: "学习中" }, { name: "已学完" }],
      listLoading: false,
      listFinished: false,
      courseList: [],
      isFinished: 0,
      size: 10,
      page: 0,
      user:''
    };
  },
  methods: {
    tabClick(name, title) {
      console.log(name, title);
      this.isFinished = name==1 ? true : false;
      this.page=0;
      console.log(this.isFinished)
      // // this.listLoading=true;
      this.courseList=[]
      this.listFinished = false;
      this.getcourse(name)
    },
    watchCourse(index) {
      console.log(index);
      this.$router.push({
        path: "/courseDetail",
        query: {
          courseId: this.courseList[index].id,
        },
      });
    },
    getcourse() {
      let that = this;
      if (that.listFinished) {
        return;
      }
      const params = {
        isFinished: this.isFinished,
        page: this.page,
        size: this.size,
        sort:'desc',
        userId:this.user.id
      };
      if (that.listLoading) {
        return;
      }
      if(this.page===0)this.courseList=[]
      that.listLoading = true;
      getMyCourse(params)
        .then((res) => {
          let totalElements = res.totalElements;
          that.courseList = that.courseList.concat(res.content);
          if (res.content.length == 0) {
            that.listFinished = true;
          } else {
            that.listFinished = false;
            this.page++;
          }
          that.listLoading = false;
        })
        .catch((res) => {
          that.listLoading = false;
        });
    },
  },
mounted(){
    this.user=this.$store.state.user.user.user
    console.log(this.user)
},
  components: {
    courseCell,
  },
};
</script>
<style lang="less" scoped>
.mycourse {
  width: 100%;
  background: #fff;
  width: 351px;
  margin:16px auto;
  padding: 0 14px;
}
</style>